import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { whatsappLink } from "@/lib/whatsapp";

const ROUTES = [
  { from: "Jodhpur", to: "Jaipur", km: "336 km", time: "6h", href: "/taxi/jodhpur-to-jaipur" },
  { from: "Jodhpur", to: "Udaipur", km: "252 km", time: "5h", href: "/taxi/jodhpur-to-udaipur" },
  { from: "Jodhpur", to: "Jaisalmer", km: "285 km", time: "5h", href: "/taxi/jodhpur-to-jaisalmer" },
  { from: "Jodhpur", to: "Mount Abu", km: "270 km", time: "5.5h", href: null },
  { from: "Jodhpur", to: "Airport", km: "6 km", time: "20 min", href: null },
  { from: "Jodhpur", to: "Railway Stn.", km: "5 km", time: "15 min", href: null },
];

export default function PopularRoutes() {
  return (
    <section id="routes" className="bg-brand-cream text-brand-ink py-24 md:py-28" data-testid="routes-section">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <div className="text-[11px] uppercase tracking-[0.28em] font-semibold text-brand-blue">Chapter V · Popular Routes</div>
            <h2 className="mt-4 font-display font-black text-4xl md:text-5xl leading-[1.05]">
              From Jodhpur <span className="italic text-brand-orange font-medium">to anywhere.</span>
            </h2>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {ROUTES.map((r, i) => (
            <motion.a
              key={i}
              href={r.href || whatsappLink(`Hi, I'd like a quote from ${r.from} to ${r.to}.`)}
              target={r.href ? undefined : "_blank"}
              rel={r.href ? undefined : "noopener noreferrer"}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.05 }}
              className="group relative rounded-3xl bg-white p-6 border border-brand-ink/8 hover:border-brand-blue transition-colors flex items-center justify-between"
              data-testid={`route-${i}`}
            >
              <div>
                <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-brand-blue/70">{r.km} · {r.time}</div>
                <div className="mt-2 font-display text-2xl font-bold flex items-center gap-2">
                  {r.from} <ArrowRight className="w-5 h-5 text-brand-orange group-hover:translate-x-1 transition-transform" /> {r.to}
                </div>
                <div className="mt-1 text-sm text-brand-ink/60">
                  {r.href ? <span className="text-brand-blue font-semibold">View route details →</span> : <span>Tap to get instant quote</span>}
                </div>
              </div>
              <div className="hidden sm:flex w-12 h-12 rounded-full bg-brand-cream group-hover:bg-brand-orange group-hover:text-white text-brand-blue items-center justify-center transition-colors">
                <ArrowRight className="w-4 h-4" />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
